import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import backgroundVideo from "../assets/sora2.mp4";
import itx from "../assets/itx.png";
import okiDoki from "../assets/okidoki.png";
import xp from "../assets/XP.png";
import { useDispatch, useSelector } from "react-redux";
import {
  authUrl,
  clientId,
  localStorageKeys,
  redirectUri,
  statusConst,
} from "../const";
import UIMessage from "../components/UIMessage";
import { userActions } from "../store/user/user-slice";
import { addToLocalStrage } from "../helper";
import LoadingSpinner from "../components/LoadingSpinner";
import { exchangeAuthCode } from "../api/authApi";
import {
  clearAuthDetails,
  decodeAndStoreInLocalStorage,
  generateRandomString,
} from "../auth/authHelper";
import { storeAuthDetails } from "../store/user/user-actions";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("An Error occurred please try again");
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(
    "Redirecting to authentication url",
  );

  const user = useSelector((state) => state.user);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (code && state && window.opener && !window.opener.closed) {
      if (state === window.localStorage.getItem("oauth_state")) {
        window.opener.postMessage({ code: code, state: state }, "*");
      }
      window.close();
    }
  }, []);

  window.addEventListener(
    "message",
    (event) => {
      if (
        event.data.code &&
        event.data.state === localStorage.getItem("oauth_state")
      ) {
        processAuthCode(event.data.code);
        localStorage.removeItem("oauth_state");
      }
    },
    false,
  );

  const processAuthCode = async (code) => {
    try {
      setLoadingMessage("Signing you up");
      const response = await exchangeAuthCode(code);
      const data = await decodeAndStoreInLocalStorage(response);
      dispatch(storeAuthDetails(data));
      dispatch(userActions.setAuthStatus(statusConst.SUCCESS));
    } catch (e) {
      if (e?.response?.data?.error) {
        setError(e.response.data.error);
      }
      dispatch(userActions.setAuthStatus(statusConst.FAILURE));
    } finally {
      setIsLoading(false);
    }
  };

  const initiateLogin = () => {
    const state = encodeURIComponent(generateRandomString(32));
    addToLocalStrage({ oauth_state: state });
    const authenticationURL = `${authUrl}/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=read&response_type=code&response_mode=form_post&state=${state}`;
    setIsLoading(true);
    setLoadingMessage("Enter your credentials and sign in");
    clearAuthDetails();
    dispatch(userActions.clearAuthData(false));
    window.open(
      authenticationURL,
      "AuthWindow",
      "width=700,height=800,top=50%,left=50%",
    );
  };

  return (
    <>
      {!user.needAuth && user.authStatus === statusConst.SUCCESS ? (
        <Navigate
          to={
            localStorage.getItem(localStorageKeys.EXPIRED_ROUTE)
              ? localStorage.getItem(localStorageKeys.EXPIRED_ROUTE)
              : "/"
          }
        />
      ) : (
        <div className="login-back">
          <ToastContainer />
          <div className="video-background">
            <video autoPlay muted loop playsInline>
              <source src={backgroundVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Overlay should be here, ABOVE the video but still BEHIND content */}
          <div className="video-overlay" />

          <div className="login-container">
            <img
              src={okiDoki}
              style={{ width: "250px", marginBottom: "-15px" }}
              alt="logo"
            />
            <h3>Transport Management</h3>
            <form
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                flexDirection: "column",
                width: "300px",
              }}
            >
              {isLoading && (
                <>
                  <h4>{loadingMessage}</h4>
                  <LoadingSpinner
                    height="100%"
                    showText={false}
                    spinner="login-loader"
                    style={{ marginBottom: "20px" }}
                  />
                </>
              )}

              <div
                style={{ width: "250px", height: "20px", marginBottom: "20px" }}
              >
                <button
                  onClick={initiateLogin}
                  type="button"
                  className="ui right floated button"
                  style={{
                    width: "100%",
                    minHeight: "40px",
                    backgroundColor: "#C72127",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    color: "black",
                    fontWeight: "bold",
                    border: "none",
                    cursor: "pointer",
                    marginBottom: "70px",
                  }}
                >
                  <img src={xp} alt="ITX Pass" style={{ height: "20px" }} />
                  Login with ITX Pass
                </button>
              </div>
              {/*<div>*/}
              {/*  <input*/}
              {/*    style={{ marginTop: "20px" }}*/}
              {/*    type="checkbox"*/}
              {/*    id="remember-me"*/}
              {/*    // checked={rememberMe}*/}
              {/*    onChange={() => {*/}
              {/*      console.log("Remember me clicked");*/}
              {/*      // setRememberMe((prevState) => !prevState);*/}
              {/*    }}*/}
              {/*  />*/}
              {/*  <label htmlFor="remember-me">Remember Me</label>*/}
              {/*</div>*/}
              {!user.needAuth && user.authStatus === statusConst.SUCCESS && (
                <UIMessage style={{ margin: "10px", minHeight: "50px" }}>
                  Success
                </UIMessage>
              )}
              {!user.needAuth && user.authStatus === statusConst.FAILURE && (
                <UIMessage
                  style={{ margin: "10px", minHeight: "50px" }}
                  type="negative"
                >
                  {error}
                </UIMessage>
              )}
              {user.error && (
                <UIMessage
                  style={{ margin: "10px", minHeight: "50px" }}
                  type="orange"
                >
                  {user.error}
                </UIMessage>
              )}
            </form>
          </div>
          <div className="footer">
            <h5 style={{ margin: 0, padding: "0 10px 0 0", color: "gray" }}>
              Powered by
            </h5>
            <img src={itx} alt="footer" />
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
